var exports = {
  "x6": "AutocompleteItem.module__button___RG1JUl",
  "kL": "AutocompleteItem.module__container___RG1JUl",
  "wH": "AutocompleteItem.module__selected___RG1JUl",
  "Qs": "AutocompleteItem.module__content___RG1JUl",
  "Kk": "AutocompleteItem.module__icon___RG1JUl",
  "Bm": "AutocompleteItem.module__nameWrapper___RG1JUl",
  "UU": "AutocompleteItem.module__name___RG1JUl",
  "h_": "AutocompleteItem.module__description___RG1JUl",
};

module.exports = exports;
